import CountNumber from '@/Components/CountNumber';
import { Link } from '@inertiajs/react';
import { Button } from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';
import offersbgimage from '@/../../public/banner/offers.png';
import '@/../css/flibcard.css'; // Ensure the correct CSS file is imported

interface Offers {
    id: number;
    name: { [key: string]: string };
    image: string;
    price: string;
    slug: string;
}

interface Props {
    offers: Offers[];


}

export default function Offers({ offers }: Props) {
    const { t, i18n } = useTranslation();

    return (
        <div className='m-5 py-5 px-8 grid grid-cols-1'>
            <div className='grid grid-cols-2 xs:grid-cols-1'>
                <div className='flex flex-col items-start'>
                    <p className=' text-custom-dark-blue  font-bold text-sm lg:text-base p-4 dark:text-white'>
                        {t('table.offers.getoffer_title')}
                    </p>

                </div>

            </div>


            <div className='my-4 px-4'>
                <div className='grid grid-cols-3 gap-8 xs:grid-cols-1'>
                    {offers.length > 0 &&
                        offers.map((item) => (
                            <div key={item.id} className='flip-card !w-full drop-shadow-3xl'>
                                <div className='flip-card-inner'>
                                    {/* Front side with image */}
                                    <div className='flip-card-front overflow-hidden'>
                                        <img loading='lazy' src={item.image} alt={item.name[i18n.language]} className='h-full w-full object-cover' />
                                    </div>

                                    {/* Back side with text */}
                                    <div className='flip-card-back bg-center bg-cover'
                                        style={{
                                            backgroundImage: `url('${offersbgimage}')`
                                        }}
                                    >
                                        <div className='flex flex-col items-center gap-4 text-white'>
                                            <p className='text-sm lg:text-base font-semibold font-sans'>{item.name[i18n.language]}</p>
                                            <p className='text-sm lg:text-base font-sans'>
                                                {item.price}
                                                {i18n.language === 'ar' ? ' ريال ' : ' SAR '}
                                            </p>
                                            <Link
                                                href={route('client.offers.show', { locale: i18n.language, slug: item.slug })}
                                            >
                                                <Button className='rounded-full p-4 font-normal font-sans hover:!bg-custom-dark-blue  hover:!text-white hover:!border-white text-sm lg:text-base !border-custom-dark-blue'>{t('table.offers.btn_offer')}</Button>
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                </div>

            </div>
            <div className='items-center lg:justify-end justify-center flex'>
                <Button className='p-5 rounded-full text-sm lg:text-base font-semibold font-sans hover:!bg-custom-dark-blue hover:!border-white hover:!text-white'>
                    <Link href={route('client.offers.index', { locale: i18n.language })}>
                        {t('table.offers.getoffer_btn')}
                    </Link>
                </Button>
            </div>
        </div>
    );
}